import React, { Component, createRef } from 'react'
import HeaderComponent from './header'

/**
 * @augments {Component<import('./interfaces').HeaderProps>}
 */
class Header extends Component {
  constructor (props) {
    super(props)
    this.headerRef = createRef()
  }

  focus () {
    this.headerRef.current && this.headerRef.current.focus()
  }

  render () {
    return <HeaderComponent {...this.props} ref={this.headerRef} />
  }
}

Header.propTypes = HeaderComponent.propTypes
Header.defaultProps = HeaderComponent.defaultProps

export default Header
